import { AWSAuthService } from "@intocare-medapp/aws/http";
import { IcOrganisation } from "@intocare-medapp/organisation/ic-organisation";

import { RavenErrorHandler } from "./handlers/raven-error-handler";
import { CommonErrorHandler } from "./handlers/common-error-handler";
import { ErrorHandlerOptions } from "./entities/error-handler-options";
import { Router } from "@angular/router";

export function errorHandlerFactory(options: ErrorHandlerOptions) {
	return (authService: AWSAuthService, icOrganisation: IcOrganisation, router: Router) => {
		// If a sentry configuration is present, return the RavenErrorHandler
		if (options.url) {
			return new RavenErrorHandler(options, authService, icOrganisation, router);
		}

		return new CommonErrorHandler();
	};
}
